<template>
  <div v-if="merchList">



    <div class="card"　v-for="merch in merchList">
      <div class="card-header">{{merch.merchandiseLabel}}</div>
      <div class="card-content">
        <div class="list-block media-list">
          <ul>
            <li class="item-content">
              <div class="item-media">
                <img :src="baseurl + merch.merchandiseIcon" width="44">
              </div>
              <div class="item-inner">

                <div style="border: #2ac845; padding-bottom: .5rem">
                      <span v-if="merch._subTitleList && merch._subTitleList.length > 0" v-for="subTitle in merch._subTitleList">
                        <span style="position:relative;color: white;background-color: white; padding: 0.1rem;"></span>
                        <span style="font-size: .7rem;color: white;background-color: #00469A;padding: 0.1rem;">{{subTitle.valueText}}</span></span>

                  <span style="font-size: .7rem;color: black;" v-if="merch._abstractList && merch._abstractList.length>0"
                        v-for="abstractTitle in merch._abstractList">
                       <span v-if="abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined">{{abstractTitle.valueText.TLNo}}</span><span v-else>{{abstractTitle.valueText}}</span></span>
                </div>

                <span style="left:0; bottom:0;font-size: 1rem;color: #3F3F3F;padding:0.2rem 0 0.2rem 0;font-weight: bold"
                      v-if="merch._titleList && merch._titleList.length > 0" v-for="title in merch._titleList">
                      <span v-if="title.valueText !== '-1'">
                        <span v-if="title.columnName === 'TVInfo'">{{title.valueText.TLNo}}</span>
                        <span v-else>{{title.valueText}}</span></span>
                    </span>


                <!--<div class="item-title-row">-->
                  <!--<div class="item-title" v-if="merch._attributesList[0]">{{merch._attributesList[0].valueText}}</div>-->
                <!--</div>-->
                <!--<div class="item-subtitle" v-if="merch._attributesList[1]">{{merch._attributesList[1].valueText}}-->
                  <!--<span v-if="merch._attributesList[2]"-->
                        <!--style="background-color: black;color: white;text-align: center;padding: 0.2rem">-->
                    <!--{{merch._attributesList[2].valueText}}-->
                  <!--</span></div>-->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-footer">
        <span  @click="response(merch)">{{buttonName2}}</span>
         <span class="goToComment"
               @click="goToComment(merch)" style="color: #0a8ddf">{{buttonName1}}</span>
      </div>
    </div>

  </div>
</template>
<script>
  import merchdata from '../../../../components/MerchandiseList.vue'
  export default {
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        merchList: []
      }
    },
    mounted () {
      var self = this
      if (this.commentMerchandise) {
        for (let i = 0; i < this.commentMerchandise.length; i++) {
          let merchandise = this.commentMerchandise[i]
          merchandise.merchandiseDetailForClient.merchandiseId = merchandise.merchandiseGuid
          merchandise.merchandiseDetailForClient.orderId = merchandise.orderGuid
          self.merchList.push(merchandise.merchandiseDetailForClient)
        }
      }
    },
    components: {
      merchdata
    },
    props: ['commentMerchandise', 'buttonName1', 'buttonName2'],
    methods: {
      goToComment (merchandise) {
        this.$router.push({name: 'myComment', query: {merchandise: JSON.stringify(merchandise)}})
      },
      response (merch) {
        this.$emit('response', merch)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// MyCommentOrder.vue?52c01a04